import React from "react";
import icon3 from "../img/svg/asset-11.svg";

const ClientCard = ({ clientData }) => {
  return (
    <>
      <section className="client-container">
        <p className="client-p1">client testimonial</p>
        <h4 className="client-h1">What our clients say</h4>
        <div className="client-sub-container">
          {clientData.map((curEle) => {
            return (
              <>
                <div className="client">
                  <span className="client-intro">
                    <img src={icon3} alt="" />

                    <h4 className="client-h2">
                      Eugene Freeman{" "}
                      <div className="client-h2-sub">Tincidunt</div>
                    </h4>
                  </span>
                  <p className="client-p3">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Voluptas, omnis.
                  </p>
                </div>
              </>
            );
          })}
        </div>
      </section>
    </>
  );
};

export default ClientCard;
